import { render, staticRenderFns } from "./RecommendGift.vue?vue&type=template&id=72dfb694&scoped=true"
import script from "./RecommendGift.vue?vue&type=script&lang=js"
export * from "./RecommendGift.vue?vue&type=script&lang=js"
import style0 from "./RecommendGift.vue?vue&type=style&index=0&id=72dfb694&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dfb694",
  null
  
)

export default component.exports